<script lang="ts">
import { defineComponent, ref } from "vue";
import Vorschlagsliste from "@/components/Vorschlagsliste/Vorschlagsliste.vue";
import { Dropdowndaten } from "@/model/Dropdowndaten";
import Logger from "js-logger";
import {inputChangeHandler} from "@/businesslogic/utils/events";

export default defineComponent({
  name: "Dropdown",
  methods: {inputChangeHandler},
  emits: ["updateVorschlag"],
  components: {
    Vorschlagsliste,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    dropdowndaten: {
      type: Dropdowndaten,
      required: true,
    },
    wertAktuell: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const selectedVorschlag = ref<number>(0);
    const gefilterteVorschlaege = ref([] as any);
    const zeigeVorschlaege = ref(false);
    const input = ref(props.wertAktuell);

    const updateVorschlag = (value: string, vorschlagZeigen: boolean) => {
      zeigeVorschlaege.value = vorschlagZeigen && value.length > 0;

      if (value != undefined) {
        input.value = value;
        gefilterteVorschlaege.value = props.dropdowndaten?.alleVorschlaege.filter((vorschlag: string) =>
          vorschlag.toLowerCase().includes(value.toLowerCase()),
        );
      } else {
        gefilterteVorschlaege.value = props.dropdowndaten?.alleVorschlaege;
      }
    };

    const clearUpdateVorschlag = () => {
      setTimeout(function () {
        if (document.activeElement === null || document.activeElement.id !== "listElement") {
          zeigeVorschlaege.value = false;
          emit("updateVorschlag", input.value);
        }
      }, 0);
    };

    const decVorschlag = () => {
      selectedVorschlag.value--;
      if (selectedVorschlag.value < 0) {
        selectedVorschlag.value = gefilterteVorschlaege.value.length - 1;
      }
    };

    const incVorschlag = () => {
      selectedVorschlag.value++;
      if (selectedVorschlag.value >= gefilterteVorschlaege.value.length) {
        selectedVorschlag.value = 0;
      }
    };

    const akzeptiereVorschlag = (value: any) => {
      Logger.log("akzeptiereVorschlag", value, selectedVorschlag.value);
      if (value == undefined) {
        input.value = gefilterteVorschlaege.value[selectedVorschlag.value];
        emit("updateVorschlag", input.value);
      } else if (gefilterteVorschlaege.value && value && value.index !== undefined) {
        selectedVorschlag.value = value.index;
        input.value = value.data;
        emit("updateVorschlag", input.value);
      }
      zeigeVorschlaege.value = false;
    };

    return {
      props,
      updateVorschlag,
      clearUpdateVorschlag,
      decVorschlag,
      incVorschlag,
      akzeptiereVorschlag,
      gefilterteVorschlaege,
      selectedVorschlag,
      zeigeVorschlaege,
      input,
    };
  },
});
</script>

<template>
  <input
    autocomplete="chrome-off"
    type="text"
    :name="name"
    :value="input"
    @focusout="clearUpdateVorschlag()"
    @input="updateVorschlag(inputChangeHandler($event), true)"
    @focus="updateVorschlag(inputChangeHandler($event), true)"
    @keydown.enter="akzeptiereVorschlag(undefined)"
    @keydown.up="decVorschlag()"
    @keydown.down="incVorschlag()"
    @keydown.tab="zeigeVorschlaege = false"
    class="c-form-control__input"
    data-cy="vorschlagcy"
    :placeholder="dropdowndaten.placeholder"
    :minlength="dropdowndaten.minlaenge"
    :maxlength="dropdowndaten.maxlaenge"
    :required="dropdowndaten.required"
    :aria-required="dropdowndaten.required"
    :data-fehlermeldung="dropdowndaten.fehlermeldung"
  />
  <vorschlagsliste
    :vorschlaege="gefilterteVorschlaege"
    :anzeigen="zeigeVorschlaege"
    :selected="selectedVorschlag"
    @update="akzeptiereVorschlag"
  />
</template>

<style scoped></style>
